import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import DmNavbarState from "./context/dmNavbarState";
import Root from "./app/root.component";

function RootComponent() {
  return (
    <DmNavbarState>
      <Root />
    </DmNavbarState>
  );
}

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: RootComponent,
  errorBoundary(err, info, props) {
    return null;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
